import { motion } from "framer-motion";
import { Gift, Car, BadgeCheck, ArrowRight } from "lucide-react";

export const RewardBanner = () => (
  <section id="recompensa" className="py-20 lg:py-28 bg-navy relative overflow-hidden scroll-mt-20" data-testid="reward-section">
    <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[var(--green-500)] opacity-20 blur-3xl" />
    <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[var(--blue-600)] opacity-25 blur-3xl" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 text-white text-xs font-bold px-3.5 py-1.5 border border-white/15">
          <Gift className="h-4 w-4 text-[var(--green-500)]" /> Pequeña recompensa por tu tiempo
        </span>
        <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
          Completa tu solicitud y llévate{" "}
          <span className="text-[var(--green-500)]">$50 de descuento</span> en tu seguro de auto.
        </h2>
        <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed max-w-xl">
          Una vez que llenes el formulario recibes al instante tu código de bono. Preséntalo al cotizar
          tu seguro de auto con nosotros y aplicamos el descuento en tus cotizaciones.
        </p>
        <ul className="mt-6 space-y-3">
          {["Sin letra pequeña ni compras obligatorias", "Válido en cotizaciones de seguro de auto con nosotros", "Se entrega inmediatamente al enviar tu solicitud"].map((t) => (
            <li key={t} className="flex items-center gap-3 text-slate-200">
              <BadgeCheck className="h-5 w-5 text-[var(--green-500)] shrink-0" /> {t}
            </li>
          ))}
        </ul>
        <a
          href="#formulario"
          className="mt-8 inline-flex items-center gap-2 btn-cta rounded-full px-6 py-3.5 font-bold"
          data-testid="reward-cta-button"
        >
          Quiero mi bono de $50 <ArrowRight className="h-4 w-4" />
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40, rotate: -2 }}
        whileInView={{ opacity: 1, y: 0, rotate: -2 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="relative mx-auto w-full max-w-md"
      >
        <div className="coupon-edge rounded-3xl bg-white p-1 shadow-2xl">
          <div className="rounded-[1.35rem] border-2 border-dashed border-slate-200 p-7">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs font-bold tracking-[0.2em] text-slate-500 uppercase">Vale de descuento</p>
                <p className="mt-1 font-heading text-6xl font-extrabold text-navy leading-none">
                  $50<span className="text-2xl align-top text-growth ml-1">USD</span>
                </p>
              </div>
              <span className="grid place-items-center h-14 w-14 rounded-2xl gradient-brand text-white">
                <Car className="h-7 w-7" />
              </span>
            </div>
            <p className="mt-4 text-slate-700 font-semibold">Descuento en servicios de seguro de auto</p>
            <p className="text-sm text-slate-500">Con las cotizaciones de Mi Protección 365</p>
            <div className="mt-6 flex items-center justify-between rounded-xl bg-slate-50 border border-slate-200 px-4 py-3">
              <span className="text-xs font-semibold text-slate-500">Código</span>
              <span className="font-mono font-extrabold tracking-[0.2em] text-navy">BONO50AUTO</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
